<template>
  <div id="phone_advantage" class="phone_advantage">
    <div class="top_img">
      <img src="//static-efe-front-h.zhangyuecdn.com/sfm-production/zycom/advantage_banner.8bd0cd01.png" alt="" />
    </div>
    <div class="subnav">
      <div class="scroll_left">
        <a
          class="advantage_nav_a"
          v-for="advantage in ADVANTAGE"
          :key="advantage.id"
          @click="toAnchor(advantage)"
          :class="{ active: activeAnchor === advantage.id }"
        >
          {{ advantage.name }}
        </a>
      </div>
    </div>
    <div class="advantage_con" v-for="advantage in ADVANTAGE" :key="advantage.name" :id="advantage.id">
      <div class="con_title">{{ advantage.name }}</div>
      <div class="con_advantage_info">{{ advantage.desc }}</div>
    </div>
  </div>
</template>
<script>
import { ADVANTAGE } from '@/config';

export default {
  name: 'Advantage',
  data() {
    return {
      ADVANTAGE,
      headerHeight: 80, // 页头高度
      activeAnchor: '', // 当前定位的锚点
      scrollTimer: null // 滚动节流定时器
    };
  },
  mounted() {
    const id = this.$route.query.id;
    if (id) {
      this.$nextTick(() => {
        this.toAnchor(id, true);
      });
    }
    this.initScroll();
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }
  },
  methods: {
    /**
     * 初始化滚动监听
     */
    initScroll() {
      window.addEventListener('scroll', this.onScroll);
      this.onScroll();
    },

    /**
     * 滚动事件处理，更新当前激活的锚点
     */
    onScroll() {
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }
      
      this.scrollTimer = setTimeout(() => {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        
        // 查找当前位置对应的锚点
        for (let i = 0; i < this.ADVANTAGE.length; i++) {
          const element = document.getElementById(this.ADVANTAGE[i].id);
          if (!element) continue;
          
          const elementTop = element.offsetTop - this.headerHeight;
          const nextElement = i < this.ADVANTAGE.length - 1 
            ? document.getElementById(this.ADVANTAGE[i + 1].id) 
            : null;
          const nextElementTop = nextElement 
            ? nextElement.offsetTop - this.headerHeight 
            : document.body.scrollHeight;
          
          if (scrollTop >= elementTop && scrollTop < nextElementTop) {
            this.activeAnchor = this.ADVANTAGE[i].id;
            break;
          }
        }
      }, 50);
    },

    /**
     * 跳转到指定锚点
     * @param {Object|String} advantage - 锚点对象或ID
     * @param {Boolean} fromRoute - 是否来自路由参数
     */
    toAnchor(advantage, fromRoute = false) {
      let targetId = '';
      
      if (fromRoute) {
        // 处理路由参数：数字索引或直接ID
        if (typeof advantage === 'string' && !isNaN(advantage)) {
          const index = parseInt(advantage);
          targetId = this.ADVANTAGE[index]?.id;
        } else {
          targetId = advantage;
        }
      } else {
        targetId = advantage.id;
      }

      if (!targetId) return;

      this.activeAnchor = targetId;
      const element = document.getElementById(targetId);
      
      if (element) {
        const targetPosition = element.offsetTop - this.headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/function.scss';

.S {
  .phone_advantage {
    padding-bottom: rem(116);
  }
  .top_img {
    img {
      width: 100%;
      height: rem(624);
      display: block;
    }
  }
  .advantage_nav_a {
    display: inline-block;
    padding: 0 rem(44);
    text-align: center;
    font-size: rem(42);
    color: #333;
    line-height: rem(122);
    &.active {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: rem(3);
        width: rem(168);
        height: rem(6);
        margin-left: rem(-84);
        background: #1680FC;
      }
    }
  }
  .subnav {
    position: sticky;
    top: rem(120);
    height: rem(122);
    background: #fbfbfb;
    box-shadow: 0 rem(-3) 0 0 #f5f5f5 inset;
    .scroll_left {
      height: rem(122);
      padding: 0 rem(16);
      overflow-x: scroll;
      white-space: nowrap;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .advantage_con {
    padding-top: rem(116);
    .con_title {
      width: rem(620);
      height: rem(148);
      line-height: rem(148);
      padding-left: rem(60);
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background: linear-gradient(145deg, #f7f8fa, rgba(247, 248, 250, 0));
      font-size: rem(60);
      color: #333;
    }
    .con_advantage_info {
      padding: rem(48) rem(60) 0;
      font-size: rem(42);
      color: #666;
      line-height: 1.5;
    }
  }
}
</style>
